export const OPEN_SEARCH_KEY_CODE = 'Slash';
export const SEARCH_MODAL_DEBOUNCE_DELAY_MS = 500;
